import {useMemo} from 'react';
import Stack from '@mui/material/Stack';
import {applyEmailPlaceholderEdit, type EmailPlaceholder} from '../../../config/emailPlaceholders';
import {readEmailMode} from '../../../config/emailModes';
import {buildAvailableVariables} from '../../../config/nodeVariables';
import type {NodeEditorV2Props} from '../types';
import EmailVariablesEditor from './EmailVariablesEditor';
import SendEmailModeRadios from './SendEmailModeRadios';

/**
 * Send Email's identity-panel controls over the dialog's draft. BUILDER has no Variables panel: Unlayer deletes
 * `[[key]]` text from its blocks, so a mapping could never reach the mail.
 */
export default function SendEmailIdentityAside(props: NodeEditorV2Props) {
    const {nodeConfig, setNodeConfig, upstreamNodes = [], readOnly} = props;
    const sources = useMemo(() => buildAvailableVariables(upstreamNodes), [upstreamNodes]);
    // Keep the API's `placeholders` key; the authoring UI calls these variables.
    const mappings: EmailPlaceholder[] = Array.isArray(nodeConfig.placeholders) ? nodeConfig.placeholders : [];

    return <Stack gap={3} sx={{minWidth: 0}}>
        <SendEmailModeRadios {...props}/>
        {readEmailMode(nodeConfig) !== 'BUILDER' && (
            <EmailVariablesEditor mappings={mappings}
                                  sources={sources} readOnly={readOnly}
                                  onEdit={edit => setNodeConfig(applyEmailPlaceholderEdit(nodeConfig, edit))}/>
        )}
    </Stack>;
}
